<template>
  <div class="unidata-editor">
    <div class="row">
      <div v-if="bLoading" class="animated fadeIn">
        <Loading :active="true" :is-full-page="false"></Loading>
      </div>
      <line-chart
        :data="serie"
        :colors="colors"
        :xtitle="xTitle"
        :ytitle="yTitle"
        :download="true"
      ></line-chart>
    </div>
    <div class="row">
      <hr />
    </div>
    <div class="row simply-editor">
      <div class="col-6 simply-item-container">
        {{ uniTranslation("GF45") }}
        <el-select v-model="chartType" placeholder="..." style="width: 100%">
          <el-option
            v-for="chart in availableCharts"
            :key="chart.id"
            :label="chart.title"
            :value="chart.id"
          ></el-option>
        </el-select>
      </div>
      <div class="col-2 simply-item-container">
        {{ uniTranslation("S1136") }}
        <VueAutonumeric
          v-model="minValue"
          style="text-align: center !important;"
          class="form-control auto-numeric"
          :options="{
            allowDecimalPadding: false,
            digitGroupSeparator: '',
            decimalCharacter: whatDecimalSeparator(),
            decimalCharacterAlternative: whatDecimalSeparatorAlternative(),
            decimalPlaces: 4,
            currencySymbol: '\u00a0€',
            currencySymbolPlacement: 's',
            roundingMethod: 'U',
            emptyInputBehavior: 'null',
            symbolWhenUnfocused: '',
            selectOnFocus: 'false',
            currencySymbol: '',
            negativePositiveSignPlacement: 'p'
          }"
        ></VueAutonumeric>
      </div>
      <div class="col-2 simply-item-container">
        {{ uniTranslation("S1138") }}
        <VueAutonumeric
          v-model="maxValue"
          style="text-align: center !important;"
          class="form-control auto-numeric"
          :options="{
            allowDecimalPadding: false,
            digitGroupSeparator: '',
            decimalCharacter: whatDecimalSeparator(),
            decimalCharacterAlternative: whatDecimalSeparatorAlternative(),
            decimalPlaces: 4,
            currencySymbol: '\u00a0€',
            currencySymbolPlacement: 's',
            roundingMethod: 'U',
            emptyInputBehavior: 'null',
            symbolWhenUnfocused: '',
            selectOnFocus: 'false',
            currencySymbol: '',
            negativePositiveSignPlacement: 'p'
          }"
        ></VueAutonumeric>
      </div>
      <div class="col-2 simply-item-container">
        {{ uniTranslation("GF30") }}
        <VueAutonumeric
          v-model="stepValue"
          style="text-align: center !important;"
          class="form-control auto-numeric"
          :options="{
            allowDecimalPadding: false,
            digitGroupSeparator: '',
            decimalCharacter: whatDecimalSeparator(),
            decimalCharacterAlternative: whatDecimalSeparatorAlternative(),
            decimalPlaces: 4,
            currencySymbol: '\u00a0€',
            currencySymbolPlacement: 's',
            roundingMethod: 'U',
            emptyInputBehavior: 'null',
            symbolWhenUnfocused: '',
            selectOnFocus: 'false',
            currencySymbol: '',
            negativePositiveSignPlacement: 'p'
          }"
        ></VueAutonumeric>
      </div>
    </div>
    <div v-if="invalidData" class="row" style="text-align: center !important;">
      <p style="color: red; width: 100%">
        {{ uniTranslation("ZZ0007") }}
      </p>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import VueAutonumeric from "../shared/VueAutonumeric";
import { Select, Option /*, Collapse, CollapseItem*/ } from "element-ui";
import Loading from "vue-loading-overlay";
import "vue-loading-overlay/dist/vue-loading.css";

import jsonHelper from "../../shared/jsonHelper";
import projectService from "../../services/backend/projectService";

export default {
  name: "Grafici",
  components: {
    "el-select": Select,
    "el-option": Option,
    VueAutonumeric,
    Loading
  },
  props: {
    projectId: {
      type: String,
      required: true
    }
  },
  data() {
    return {
      serie: [],
      colors: [],
      minValue: 0,
      maxValue: 0,
      stepValue: 0,
      chartType: 0,
      availableCharts: [],
      availableChartsData: {},
      bLoading: false
    };
  },
  computed: {
    ...mapGetters("_prjModule", ["projects"]),
    invalidData: function() {
      let bStop = false;
      if (this.minValue <= 0) bStop = true;
      if (this.maxValue <= 0) bStop = true;
      if (this.stepValue <= 0) bStop = true;
      if (this.maxValue <= this.minValue) bStop = true;
      if (this.chartType <= 0) bStop = true;
      return bStop;
    },
    xTitle: function() {
      if (this.availableChartsData[this.chartType]) {
        let project = this.projects[this.projectId];
        let root = this.availableChartsData[this.chartType][1];
        let label = jsonHelper.getProperty(project, root + ".label");
        let um = jsonHelper.getProperty(project, root + ".input.usrValue.um");
        if (um == "") um = "Nr.";
        let retVal = this.uniTranslation(label) + " [" + um + "]";
        return retVal;
      } else {
        return "";
      }
    },
    yTitle: function() {
      if (this.availableChartsData[this.chartType]) {
        let project = this.projects[this.projectId];
        let root = this.availableChartsData[this.chartType][2];
        let label = jsonHelper.getProperty(project, root + ".label");
        let um = jsonHelper.getProperty(project, root + ".output.usrValue.um");
        if (um == "") um = "Nr.";
        let retVal = this.uniTranslation(label) + " [" + um + "]";
        return retVal;
      } else {
        return "";
      }
    }
  },
  watch: {},
  mounted() {
    var that = this;
    let project = this.projects[this.projectId];
    projectService.availableCharts(project).then(data => {
      that.availableCharts = [];
      that.availableChartsData = data;
      for (let id in data) {
        that.availableCharts.push({
          id: id,
          title: that.uniTranslation(data[id][0]),
          umX: data[id][1],
          umY: data[id][2]
        });
      }
      if (that.availableCharts) this.chartType = that.availableCharts[0].id;
    });
  },
  methods: {
    whatDecimalSeparator: function() {
      var n = 1.1;
      n = n.toLocaleString().substring(1, 2);
      return n;
    },
    whatDecimalSeparatorAlternative: function() {
      var n = this.whatDecimalSeparator();
      if (n == ",") return ".";
      if (n == ".") return ",";
      return n;
    },
    generateChart: function() {
      if (this.invalidData) return;
      if (this.bLoading) return;
      let project = this.projects[this.projectId];
      let chartOptions = {
        chartType: this.chartType,
        minValue: this.minValue,
        maxValue: this.maxValue,
        step: this.stepValue,
        project: project
      };
      this.bLoading = true;
      projectService.projectChart(chartOptions).then(data => {
        this.bLoading = false;
        this.updateChart(data);
      });
    },
    updateChart: function(data) {
      if (data) {
        var that = this;
        this.colors = [];
        this.colors.push(data.color);
        let serieP = data.data;
        this.serie = [];
        this.serie.push({ name: that.uniTranslation(data.title), data: serieP });
      }
    }
  }
};
</script>

<style lang="scss">
$input-height: 40px;
.no-border-bottom {
  div {
    .el-collapse-item__header {
      border-bottom: none;
    }
  }
}
.simply-editor {
  background-color: transparent;
  margin: 0px 5px 20px 0px;
  padding: 5px 0;
  //width: 100%;
  outline: none;

  .simply-item-container {
    border: none;
    height: $input-height !important;
    //padding: 0 5px;

    /* .select {
      border: none;
    } */

    .form-control {
      //padding: 0px;
      border-radius: 5px;
      height: $input-height !important;

      &.el-select {
        .el-input {
          .el-input__inner {
            height: $input-height !important;
            //padding: 0px 25px 0px 5px;
          }
        }
      }
    }

    .form-control:focus {
      box-shadow: none;
    }

    .form-control:disabled {
      background-color: #e8e8e8;
    }
  }
}
</style>
